var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcOffline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0303 10.8807C13.0324 10.8791 13.0344 10.8774 13.0364 10.8758C13.5937 10.4138 13.9038 9.73439 13.9038 8.90769C13.9038 8.02022 13.4972 7.35421 12.9352 6.92439C12.5823 6.65458 12.1761 6.4817 11.7765 6.38626C11.3559 4.48023 9.86963 3.25 8.07692 3.25C7.386 3.25 6.77494 3.43435 6.26297 3.73947C6.18416 3.78643 6.11709 3.84558 6.06272 3.91307L7.12502 4.97537C7.39032 4.83661 7.70598 4.75 8.07692 4.75C9.19509 4.75 10.2226 5.56804 10.3767 7.12025C10.4134 7.48909 10.7139 7.77586 11.0841 7.79514C11.4205 7.81266 11.7739 7.92467 12.024 8.11593C12.2499 8.28868 12.4038 8.52974 12.4038 8.90769C12.4038 9.33373 12.2588 9.57197 12.0791 9.72093C12.0404 9.75298 12.0058 9.78809 11.9753 9.82563L13.0303 10.8807Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59434 5.86441C2.80864 6.38063 2.25 7.23207 2.25 8.4C2.25 10.2768 3.79781 11.5192 5.53846 11.5192H9.24917L7.74917 10.0192H5.53846C4.48681 10.0192 3.75 9.3155 3.75 8.4C3.75 7.69113 4.1154 7.21979 4.69645 6.96651L3.59434 5.86441Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.46967 3.46967C3.76256 3.17678 4.23744 3.17678 4.53033 3.46967L12.7803 11.7197C13.0732 12.0126 13.0732 12.4874 12.7803 12.7803C12.4874 13.0732 12.0126 13.0732 11.7197 12.7803L3.46967 4.53033C3.17678 4.23744 3.17678 3.76256 3.46967 3.46967Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOffline);
export default __webpack_public_path__ + "static/media/ic_offline.9d55dc1f71990ea0c48932a22a533e18.svg";
export { ForwardRef as ReactComponent };